export const PROFILE_PHOTO_UPDATED_EVENT = 'profile-photo-updated';

export const notifyProfilePhotoUpdated = (photo) => {
  window.dispatchEvent(
    new CustomEvent(PROFILE_PHOTO_UPDATED_EVENT, {
      detail: { photo: photo || null },
    })
  );
};
